import React from 'react';
import { useActions } from '../../hooks/useStore';
import { useSessionData } from '../../hooks/useSessionData';
import AddRelationshipModal from './AddRelationshipModal';
import type { NPC, Monster, PartyMember, Deity, EntityType } from '../../types/types';

interface AddRelationshipModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for AddRelationshipModal (ADR-034).
 * Owns store access for rosters and the addRelationship action.
 */
const AddRelationshipModalContainer: React.FC<AddRelationshipModalContainerProps> = ({ isOpen, onClose }) => {
  const npcs: NPC[] = useSessionData(session => session.roster.npcs, []);
  const monsterRoster: Monster[] = useSessionData(session => session.cache.monsterRoster, []);
  const partyRoster: PartyMember[] = useSessionData(session => session.roster.partyRoster, []);
  const deities: Deity[] = useSessionData(session => session.cache.deities, []);
  const actions = useActions();

  const handleAddRelationship = async (
    entity1Id: number,
    entity1Type: EntityType,
    entity2Id: number,
    entity2Type: EntityType,
    type: string,
  ): Promise<boolean> => {
    return actions.addRelationship(entity1Id, entity1Type, entity2Id, entity2Type, type, null);
  };

  return (
    <AddRelationshipModal
      isOpen={isOpen}
      onClose={onClose}
      npcs={npcs}
      monsterRoster={monsterRoster}
      partyRoster={partyRoster}
      deities={deities}
      onAddRelationship={handleAddRelationship}
    />
  );
};

export default AddRelationshipModalContainer;
